import React from 'react';
import { CommentListEventItem } from './CommentListEventItem';
import { Trans } from '@lingui/react/macro';
import { faFilePlus } from '@fortawesome/pro-light-svg-icons';
import { useIsBuyer, useGetActiveProjectId } from '@/utils/hooks';
import { CommentMessage } from '@ygtechnologies/bygr-frontend-chat';

interface CommentListEventItemChangeRequestProps {
    comment: CommentMessage;
}

interface Data {
    changeRequestId: number;
    status: Status;
}

enum Status {
    Closed = 1,
}

const getUrl = (isBuyer: boolean, data: Data, projectId: number | undefined) => {
    if (isBuyer) {
        return `/change-requests/${data.changeRequestId}/offer`;
    } else {
        return `/projects/${projectId}/changes/all/${data.changeRequestId}`;
    }
};

export const CommentListEventItemChangeRequest: React.FC<CommentListEventItemChangeRequestProps> = ({ comment }) => {
    var data: Data = comment.data;
    var isBuyer = useIsBuyer();
    var currentProject = useGetActiveProjectId();
    return (
        <CommentListEventItem
            title={
                <>
                    <Trans>Change request #{data.changeRequestId} closed</Trans>
                </>
            }
            topText={
                <Trans>
                    Request #{data.changeRequestId} closed by {comment.sentByProfileName}
                </Trans>
            }
            bottomText={<Trans>Request #{data.changeRequestId} can be reviewed via the request tab</Trans>}
            buttonText={<Trans>Review change request</Trans>}
            url={getUrl(isBuyer, comment.data, currentProject)}
            icon={faFilePlus}
        />
    );
};
